module.exports = __webpack_public_path__ + "static/media/contact.53982e80.svg";